import { useContext } from 'react';
import { ThemeCtx } from '../contexts/theme';

const useTheme = () => useContext(ThemeCtx);

export default useTheme;
